import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

// Redux
import { useAppSelector, useAppDispatch } from '../../../../redux/hook';
import { fetchReaderReportById } from '../../../../redux/slices/readerReportSlice';
import { fetchProcessStatusBySessionId } from '../../../../redux/slices/scanSessionSlice';
import { fetchReaderByImei } from '../../../../redux/slices/readerSlice';

// Types
import { ProcessStatus } from '../../../../types/ProcessStatus';
import { FilterableTypes } from '../../../../types/FilterableTypes';

// Components
import ProcessSightings from '../../sightings/processSightings';
import { ReportSummary } from './reportSummary';

export default function MobileReaderReportDetail(): JSX.Element {
  const { reportId } = useParams();
  const location = useLocation();
  const [totalCount, setTotalCount] = useState<number>(0);

  const source = location.state?.source;

  const readerReportState = useAppSelector((state) => state.readerReports);
  const prevReportState = useRef<ProcessStatus | undefined>(undefined);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (reportId) {
      dispatch(fetchReaderReportById({ filters: [{ reportId: reportId, filterType: FilterableTypes.Equals }] } as any));
    }
  }, [reportId]);

  useEffect(() => {
    if (readerReportState?.readerReport?.imei) {
      dispatch(fetchReaderByImei(readerReportState.readerReport.imei));
    }
  }, [readerReportState?.readerReport?.imei]);

  useEffect(() => {
    if (readerReportState.readerReport) dispatch(fetchProcessStatusBySessionId(readerReportState.readerReport?.reportId));
  }, [readerReportState.readerReport]);

  const fetchProcessStatus = () => {
    if (readerReportState.readerReport) {
      dispatch(fetchProcessStatusBySessionId(readerReportState.readerReport.reportId)).then((x: any) => {
        if (prevReportState.current === ProcessStatus.Pending && x.payload.data !== ProcessStatus.Pending) {
          window.location.reload();
        } else if (x.payload.status >= 200 && x.payload.status < 300) {
          if (x.payload.data === ProcessStatus.Pending) {
            prevReportState.current = x.payload.data;
            window.setTimeout(fetchProcessStatus, 5000);
          }
        }
      });
    }
  };

  useEffect(() => {
    fetchProcessStatus();
  }, [readerReportState.readerReport]);

  const handleTotalCountChange = useCallback((count: number) => {
    setTotalCount(count);
  }, []);

  return (
    <>
      <ReportSummary report={readerReportState.readerReport ?? null} totalCount={totalCount} source={source} />
      <ProcessSightings showMap={true} enableDeepLinks={false} enableExport={false} onTotalCountChange={handleTotalCountChange} />
    </>
  );
}
